import React from 'react';

import { FlexColumn, Gap } from 'ui-components/components/flex';

import { SetupOrdersCard, VerifyOrdersCard, VerifyInventoryCard } from './cards';
import { useReadyToPickContext } from './context/ready-to-pick-context';
import { messages } from './messages';
import style from './ready-to-pick.module.less';
import { SimpleModal } from '../../../components/simple-modal/simple-modal';
import { useInventoryTrackingEnabled } from '../../../hooks/use-seller-setting';

const getMessages = (isBatch) => {
  if (!isBatch) {
    return {
      modalTitle: messages.modalHeaderMessageOrder,
      step1Title: messages.step1TitleOrders,
      step1Body: messages.step1BodyOrders,
      step2Body: messages.step2BodyOrders,
    };
  }
  return {
    modalTitle: messages.modalHeaderMessageBatch,
    step1Title: messages.step1TitleBatches,
    step1Body: messages.step1BodyBatches,
    step2Body: messages.step2BodyBatches,
  };
};

/**
 * @param {object} props
 * @param {boolean} props.isBatch
 * @param {() => void} props.onClose
 * @returns {JSX.Element}
 */
export const ReadyToPickModal = ({ isBatch, onClose }) => {
  const { canCompleteModal, isLoadingConfirm, onModalCompletion } = useReadyToPickContext();
  const inventoryTrackingIsEnabled = useInventoryTrackingEnabled();
  const messagesObj = getMessages(isBatch);

  return (
    <SimpleModal
      actionMessage={messages.modalActionMessage}
      cancelMessage={messages.modalCancelMessage}
      headerMessage={messagesObj.modalTitle}
      isActionDisabled={!canCompleteModal || isLoadingConfirm}
      onAction={onModalCompletion}
      onCancel={onClose}
      onClose={onClose}
      size='medium'
    >
      <FlexColumn className={style['ready-to-pick-modal']} gap={Gap.Space24}>
        <SetupOrdersCard messages={messagesObj} />
        <VerifyOrdersCard messages={messagesObj} />
        {inventoryTrackingIsEnabled ? <VerifyInventoryCard /> : null}
      </FlexColumn>
    </SimpleModal>
  );
};
